import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 代付订单列表接口
export const getOrderList = (params: any) => request({
    url: '/manage/payout-order',
    method: 'get',
    params
})

// 代付订单详情
export const getOrderInfo = (params: any) => request({
    url: '/manage/payout-order/' + params.ordernumber,
    method: 'get',
    params
})

// 修改代付订单状态
export const setOrder = (data: any) => request({
    url: '/manage/payout-order/' + data.ordernumber + '/change/status',
    method: 'put',
    data
})

// 代付订单导出
export const orderExport = (data: any) => request({
    url: '/manage/payout-order-export' + objToUrlParams(data),
    method: 'post'
})

// 代付详情
export const getWithdrawInfo = (params: any) => request({
    url: '/manage/order/' + params + '/withdraw-info',
    method: 'get'
})

// 修改成功代付订单状态
export const setSuccessStatus = (data: any) => request({
    url: '/manage/success-payout-order/' + data.ordernumber + '/change/status',
    method: 'put',
    data
})

// 修改驳回代付订单接口
export const payOutReject = (data: any) => request({
    url: '/manage/payout-order/' + data.ordernumber + '/regret',
    method: 'put',
    data
})

